import { render } from "./AllDeals.vue?vue&type=template&id=6760fe62&scoped=true"
import script from "./AllDeals.vue?vue&type=script&lang=js"
export * from "./AllDeals.vue?vue&type=script&lang=js"

import "./AllDeals.vue?vue&type=style&index=0&id=6760fe62&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6760fe62"]])

export default __exports__